<div class="toast-container">
  <div *ngFor="let toast of toasts" [@toastAnimation]="'visible'" [ngClass]="getToastClass(toast.type)" class="toast-item">
    <div class="toast-background">
      <div class="toast-content">
        <div class="toast-icon" [ngClass]="getIconClass(toast.type)">
          <!-- Error Icon -->
          <svg *ngIf="toast.type === 'error'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z" />
          </svg>
          <!-- Warning Icon -->
          <svg *ngIf="toast.type === 'warning'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
            <path d="M12 5.99L19.53 19H4.47L12 5.99M12 2L1 21h22L12 2zm1 14h-2v2h2v-2zm0-6h-2v4h2v-4z" />
          </svg>
          <!-- Success Icon -->
          <svg *ngIf="toast.type === 'success'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" />
          </svg>
          <!-- Info Icon -->
          <svg *ngIf="toast.type === 'info'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z" />
          </svg>
        </div>
        <div class="toast-message">
          <h4 class="toast-title">{{ toast.title }}</h4>
          <p class="toast-text">{{ toast.message }}</p>
        </div>
      </div>
      <app-button [icon]="true" variant="invisible" color="secondary" (click)="closeToast(toast.id)" [ariaLabel]="'aria.closeToast' | transloco"><i class="fa fa-times"></i></app-button>
      
      <!-- Progress bar for auto-closing toasts -->
      <div *ngIf="hasProgressBar(toast)" class="toast-progress-container">
        <div class="toast-progress" [style.width.%]="getProgress(toast.id)"></div>
      </div>
    </div>
  </div>
</div>
